var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDateBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74121 7.64435C6.74121 7.35253 6.97778 7.11597 7.26959 7.11597H15.9613C16.2531 7.11597 16.4897 7.35253 16.4897 7.64435C16.4897 7.93617 16.2531 8.17273 15.9613 8.17273H7.26959C6.97778 8.17273 6.74121 7.93617 6.74121 7.64435Z",
    fill: "#146EAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92627 11.3463C6.92627 11.0544 7.16283 10.8179 7.45465 10.8179H13.2789C13.5707 10.8179 13.8073 11.0544 13.8073 11.3463C13.8073 11.6381 13.5707 11.8746 13.2789 11.8746H7.45465C7.16283 11.8746 6.92627 11.6381 6.92627 11.3463Z",
    fill: "#146EAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6568 2C7.94862 2 8.18518 2.23656 8.18518 2.52838V5.29562C8.18518 5.58743 7.94862 5.824 7.6568 5.824C7.36498 5.824 7.12842 5.58743 7.12842 5.29562V2.52838C7.12842 2.23656 7.36498 2 7.6568 2Z",
    fill: "#146EAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3026 2C13.5944 2 13.8309 2.23656 13.8309 2.52838V5.29562C13.8309 5.58743 13.5944 5.824 13.3026 5.824C13.0107 5.824 12.7742 5.58743 12.7742 5.29562V2.52838C12.7742 2.23656 13.0107 2 13.3026 2Z",
    fill: "#146EAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41892 3.75483C5.51905 3.64492 5.66085 3.58228 5.80953 3.58228H16.4111C16.7029 3.58228 16.9395 3.81884 16.9395 4.11066V15.4717C16.9395 15.7635 16.7029 16.0001 16.4111 16.0001H3.65338C3.36156 16.0001 3.125 15.7635 3.125 15.4717V6.47761C3.125 6.34598 3.17413 6.21909 3.26277 6.12179L5.41892 3.75483ZM6.04295 4.63904L4.18176 6.68219V14.9433H15.8827V4.63904H6.04295Z",
    fill: "#146EAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDateBlue);
export default __webpack_public_path__ + "static/media/icoDateBlue.3ff9783587f7c444131461b63de72d97.svg";
export { ForwardRef as ReactComponent };